import React from "react"
import { useNavigate } from "react-router-dom"

import { Akrutibuildconimages } from "../constants"
import { motion } from "framer-motion"
import { fadeIn } from "../utils/motion"

const AkrutibuildconCard = ({ image, index }) => {
  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      viewport={{ once: true }}
      variants={fadeIn("left", "spring", index * 0.3, 0.4)}
      className="shadow-card"
    >
      <img src={image} alt="building" />
    </motion.div>
  )
}

function Akrutibuildcon() {
  const navigate = useNavigate()

  const handleGoHome = () => {
    navigate(-1)
  }
  return (
    <div className="pt-20 px-[15px] md:px-[40px] lg:px-[60px] xl:px-[80px] 2xl:px-[100px] w-full bg-white">
      <div className="pt-6 px-0 md:px-7">
        <div className="top-left-button " onClick={handleGoHome}>
          Go back
        </div>{" "}
        <motion.h2
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={fadeIn("left", "spring", 0.3, 0.4)}
          className="text-4xl lg:text-5xl leading-tight md:leading-normal font-medium text-left"
        >
          <span className="font-leading text-black">
            About Akruti Buildcon:
          </span>
        </motion.h2>
        <motion.p
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={fadeIn("right", "tween", 0.5, 0.75)}
          className="mt-10 text-left text-black text-[17px] lg:text-[18px] pb-10"
        >
          Akruti Buildcon is a dedicated subsidiary of Akruti Concept Studio, specializing in crafting comprehensive building plans and layouts. With a keen emphasis on precision and functionality, Akruti Buildcon works closely with its parent company to deliver well-structured and aesthetically pleasing designs for diverse construction projects.
        </motion.p>
        <motion.h2
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={fadeIn("left", "spring", 0.3, 0.4)}
          className="text-3xl lg:text-4xl leading-tight md:leading-normal  text-left"
        >
          <span className="font-leading text-black tracking-tight">
            Our plans:
          </span>
        </motion.h2>
        <motion.p
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={fadeIn("right", "tween", 0.5, 0.75)}
          className="mt-6 text-left text-black text-[17px] lg:text-[18px]"
        >
          These are some of our Building plans over the years...
        </motion.p>
        <motion.a
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={fadeIn("right", "tween", 0.7, 0.75)}
          href="mailto:akrutibuildcon@gmail.com"
          className=" italic text-black text-left flex mt-4 underline underline-offset-1 font-medium"
        >
          email: akrutibuildcon@gmail.com
        </motion.a>
      </div>
      <div className="pt-10 pb-12  flex flex-col sm:grid grid-cols-2 gap-6 mx-auto  max-w-[85vw] md:max-w-[70vw] ">
        {Akrutibuildconimages.map((image, index) => (
          <AkrutibuildconCard
            key={` journey-${index}`}
            index={index}
            {...image}
          />
        ))}
      </div>
    </div>
  )
}

export default Akrutibuildcon
